import { Component } from 'react'
import {Layout,Menu,Tooltip} from 'antd';
import {UserOutlined,HomeOutlined,LogoutOutlined} from '@ant-design/icons';
import withNavigate from '../components/withNavigate';

const menuItems = [
    { key: '1', label: <Tooltip title="Backend User Managed">Backend User Managed</Tooltip>, icon: <HomeOutlined /> },
    { key: '2', label: <Tooltip title="Subscription User List">Subscription User List</Tooltip>, icon: <UserOutlined /> },
    { key: '3', label: <Tooltip title="Logout">Logout</Tooltip>, icon: <LogoutOutlined /> },
  ];

const { Sider } = Layout;
class SiderMenu extends Component {

  handleChangePage = (pageItem) =>{
    switch(pageItem.key){
        case "1":
          this.props.navigate('/admin/adminUserList');
          break;
        case "2":
          this.props.navigate('/admin/userList');
          break;
        case "3":
          sessionStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          this.props.navigate('/admin/login');
          break;
        default:
          console.warn("未知handleChangePage")  
    };
  }
  render() {
    const { location } = this.props;
    let selectedKey = '1';
    if(location.pathname === '/admin/adminUserList') selectedKey = '1';
    if(location.pathname === '/admin/userList') selectedKey = '2';

    return (
         <Sider breakpoint="lg" collapsedWidth="0" theme="dark">
            <img
              src="/assets/logo.png"
              alt="Admin Logo"
              style={{ maxHeight: '100%', maxWidth: '90%', objectFit: 'contain',margin:'5%',marginTop:'15%' }}
            />
          <Menu theme="dark" mode="inline" selectedKeys={[selectedKey]} items={menuItems} onClick={this.handleChangePage}></Menu>
        </Sider>
    )
  }
}
export default withNavigate(SiderMenu);